import React from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
export function ProofSection() {
  return <Section data-id="element-210">
      <div className="max-w-4xl mx-auto" data-id="element-211">
        <div className="text-center mb-16" data-id="element-212">
          <h2 className="text-4xl md:text-5xl mb-4" data-id="element-213">WHAT CHANGES IN 14 DAYS</h2>
          <p className="text-xl text-slate-400 font-inter" data-id="element-214">
            The timeline to a faster cognitive processor.
          </p>
        </div>

        <div className="space-y-8 relative before:absolute before:inset-0 before:ml-5 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-tactical-cyan/30 before:to-transparent" data-id="element-215">
          {[{
          day: 'DAY 4',
          text: "Your child will stop looking at the grass and start 'pinging' the horizon."
        }, {
          day: 'DAY 9',
          text: 'They will naturally perform shoulder checks while the ball is in flight.'
        }, {
          day: 'DAY 14',
          text: 'Their decision-making speed will be visually faster than their opponents, allowing them to dictate the game instead of chasing it.'
        }].map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.2
        }} className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-216">
              <div className="flex items-center justify-center w-10 h-10 rounded-full border-4 border-tactical-dark bg-tactical-cyan text-tactical-dark shadow-[0_0_15px_rgba(34,211,238,0.5)] shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-217">
                <div className="w-2 h-2 bg-tactical-dark rounded-full" data-id="element-218"></div>
              </div>

              <div className="w-[calc(100%-4rem)] md:w-[calc(50%-3rem)] bg-tactical-surface border border-tactical-surface2 p-6 rounded-xl group-hover:border-tactical-cyan/50 transition-colors" data-id="element-219">
                <h4 className="text-tactical-cyan font-oswald text-xl mb-2" data-id="element-220">
                  {item.day}
                </h4>
                <p className="text-slate-300 font-inter" data-id="element-221">{item.text}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </Section>;
}